import * as actions from "./actions";
import initialState from "./initialState";

export default (state = initialState, action) => {
  switch (action.type) {
    case actions.ADD_NEW_MESSAGE: {
      return {
        ...state,
        newMessages: [action.payload, ...state.newMessages],
        isReloadNotifications: false
      }
    }
    case actions.CLEAR_NEW_MESSAGES: {
      return {
        ...state,
        newMessages: [],
        isReloadNotifications: true
      }
    }
    case actions.SET_IS_RELOAD_NOTIFICATIONS: {
      return {
        ...state,
        isReloadNotifications: action.payload
      }
    }
    case actions.SET_IS_RELOAD_JOBS: {
      return {
        ...state,
        isReloadJobs: action.payload
      }
    }
    default:
      return state;
  };
};